<script setup=""></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 32 32">
    <path fill="currentColor" d="M24.25 17v10h-5.5v-6h-5.5v6h-5.5V17H5L16 5l11 12h-2.75Zm-.917-5.907V6h-2.75v2.093l2.75 3Z" />
  </svg>
</template>
